module.exports = __webpack_public_path__ + "img/gps.a889c501.jpg";